import { speakers } from '../../data/landingData';

export const Speakers = () => {
  return (
    <section 
      id="speakers" 
      className="py-24 px-6 bg-[#0A0A0A]"
      data-testid="speakers-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
            Your Guides
          </p>
          <h2 className="font-cormorant text-4xl md:text-5xl font-medium text-white mb-4">
            Meet Your Guides
          </h2>
          <p className="text-zinc-400 font-manrope max-w-2xl mx-auto">
            Learn from leaders who have walked the path and are committed to your transformation
          </p>
        </div>

        {/* Speakers grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {speakers.map((speaker, index) => (
            <div
              key={index}
              className="group relative rounded-2xl overflow-hidden bg-[#111111] border border-white/5 hover:border-[#D4AF37]/30 transition-all"
              data-testid={`speaker-${index}`}
            >
              {/* Image */}
              <div className="aspect-[3/4] relative overflow-hidden">
                {speaker.image ? (
                  <img
                    src={speaker.image}
                    alt={speaker.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-[#D4AF37]/20 to-[#8C6239]/20 flex items-center justify-center">
                    <span className="text-6xl font-cormorant font-medium text-[#D4AF37]">
                      {speaker.initials}
                    </span>
                  </div>
                )}
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
              </div>

              {/* Content overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-[#D4AF37] font-manrope text-xs uppercase tracking-wider mb-1">
                  {speaker.role}
                </p>
                <h3 className="font-cormorant text-2xl font-medium text-white mb-1">
                  {speaker.name}
                </h3>
                <p className="text-zinc-500 font-manrope text-sm mb-3">
                  {speaker.credentials}
                </p>
                <p className="text-zinc-400 font-manrope text-sm leading-relaxed line-clamp-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  {speaker.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
